'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = require('./actions');

var _util = require('./util');

exports.default = function (Component, store) {
  return new Promise(function (resolve, reject) {
    if (!Component.__withQueries) {
      return resolve();
    }

    var _Component$__withQuer = Component.__withQueries(),
        queries = _Component$__withQuer.queries;

    var payload = queries.map(function (q) {
      return q.init();
    });

    store.dispatch((0, _actions.init)(payload));
    store.subscribe(function () {
      if (isComplete(store, payload)) {
        resolve();
      }
    });
  });
};

var isComplete = function isComplete(store, queries) {
  var _store$getState = store.getState(),
      requests = _store$getState.requests;

  return queries.every(function (_ref) {
    var name = _ref.name,
        params = _ref.params;

    var key = (0, _util.serialize)(name, params);
    var request = requests[key] || {};

    return request.loaded;
  });
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@jump/pages/lib/performQueries.js
// module id = 260
// module chunks = 0